// Address links open a MoneyFlow for that address straight away (the
// /instant-moneyflow page), skipping the creation form, instead of the
// explorer.
export const instantMoneyflowPath = (network: string, address: string) =>
    `/instant-moneyflow?${new URLSearchParams({ network, address })}`

// The zero address stands for mints and burns: nothing to trace from it
export const isTraceableAddress = (address: string) => !/^(0x)?0{40}$/i.test(address)
